<img class="icon" src="/assets/icons/rdata/verified.svg" alt="Verified">
Verified Contract Data
<lib-tooltip>If you see this icon, the submission has been verified with
  a contract confirming these numbers are accurate.</lib-tooltip>